import React, { useContext } from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Typography } from "@material-ui/core"
import { theme, size } from "../config"
import { Theme } from "../components/Context"
const useStyles = makeStyles(() => {
  return {
    Price: {
      display: "flex",
      justifyContent: "center",
      aligItems: "center",
      width: "fit-content;",
      padding: `${size.small}px ${size.normal}px`,
      // borderRadius: `0 50% 50% 0`,
      borderRadius: `0 ${size.small}px ${size.small}px 0`,
      background: props => props.red,
      color: props => props.white,
      fontWeight: "bolder",
      marginBottom: "auto",
      fontSize: "1.1em",
    },
  }
})
const TagPrice = ({ children, className }) => {
  const color = theme(useContext(Theme))
  const classes = useStyles(color)
  return (
    <Typography className={`${classes.Price} ${className}`} variant="caption">
      {children}
    </Typography>
  )
}

export default TagPrice
